/*
 * Author: Harper Yan
 * File Created: Sunday, 24-07-21 10:52 pm
 * Last Modified: Wednesday, 25-01-22 02:51 pm, by Harper Yan
 */

import { Icon } from './Icon';
import { IconType } from './icons';
import { IllustrationType } from './illustrations';
import { LogoType } from './logos';

export { Icon };
export type { IconType, IllustrationType, LogoType };
